import {addFilterParameters} from 'Shared/utilities/addFilterParameters';

export const baseURL = 'api/policies/v1';

export const getAPIUrl = (url: string, filterParams?: any) => `${baseURL}/${url}${addFilterParameters(filterParams)}`;
